var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import chmService from "@/core/services/chmService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Grupo_Setor_Etapa_ChamadoActions } from "@/store/enums/chmEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Grupo_Setor_Etapa_ChamadoModule = class Grupo_Setor_Etapa_ChamadoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Grupo_Setor_Etapa_ChamadoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            chmService.getFile("Grupo_Setor_Etapa_Chamado/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Grupo_Setor_Etapa_Chamado.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Grupo_Setor_Etapa_ChamadoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            chmService.postFile("Grupo_Setor_Etapa_Chamado/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Grupo_Setor_Etapa_ChamadoActions.POST_GRUPO_SETOR_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.post("Grupo_Setor_Etapa_Chamado/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Grupo_Setor_Etapa_ChamadoActions.PUT_GRUPO_SETOR_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.put("Grupo_Setor_Etapa_Chamado/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Grupo_Setor_Etapa_ChamadoActions.DELETE_GRUPO_SETOR_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.delete("Grupo_Setor_Etapa_Chamado/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Grupo_Setor_Etapa_ChamadoActions.DELETE_RANGE_GRUPO_SETOR_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.delete("Grupo_Setor_Etapa_Chamado/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Grupo_Setor_Etapa_ChamadoActions.FILTER_GRUPO_SETOR_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.post("Grupo_Setor_Etapa_Chamado/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Grupo_Setor_Etapa_ChamadoActions.GET_GRUPO_SETOR_ETAPA_CHAMADO]() {
        return new Promise(resolve => {
            chmService.get("Grupo_Setor_Etapa_Chamado/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Grupo_Setor_Etapa_ChamadoActions.GETWITHDISABLED_GRUPO_SETOR_ETAPA_CHAMADO]() {
        return new Promise(resolve => {
            chmService.get("Grupo_Setor_Etapa_Chamado/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Grupo_Setor_Etapa_ChamadoActions.GET_BY_ID_GRUPO_SETOR_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.get("Grupo_Setor_Etapa_Chamado/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_Setor_Etapa_ChamadoModule.prototype, _k, null);
Grupo_Setor_Etapa_ChamadoModule = __decorate([
    Module
], Grupo_Setor_Etapa_ChamadoModule);
export default Grupo_Setor_Etapa_ChamadoModule;
//# sourceMappingURL=Grupo_Setor_Etapa_ChamadoModule.js.map